// v2/components/BrandLogo.js — ortak arac marka logosu
// Logo varsa /urun-gorsel/marka_logolari/<marka_id>.png gosterir; yoksa (404)
// renkli kisaltma rozetine duser. 404 donen markalar oturum boyunca tekrar istenmez.
// Boyutlar: xs (30x18) | sm (40x24) | md (48x28) | lg (64x38)
import React, { useState, useEffect } from 'react';
import { brandLogo, brandColor, brandShort } from '../constants/catalogVisuals';
import styles from './BrandLogo.module.css';

const logoYok = new Set();

export default function BrandLogo({
  id, name = '', size = 'md', className = '', title, alt = '',
}) {
  const url = brandLogo(id);
  const [hata, setHata] = useState(() => !url || logoYok.has(id));

  useEffect(() => { setHata(!url || logoYok.has(id)); }, [id, url]);

  const cls = `${styles.mark} ${styles[size] || styles.md} ${className}`;

  if (!hata) {
    return (
      <span className={`${cls} ${styles.logo}`} title={title}>
        <img
          className={styles.img} src={url} alt={alt}
          loading="lazy" decoding="async" draggable={false}
          onError={() => { logoYok.add(id); setHata(true); }}
        />
      </span>
    );
  }
  return (
    <span className={`${cls} ${styles.short}`} style={{ background: brandColor(id) }} title={title}>
      {brandShort(id, name)}
    </span>
  );
}
